"use strict";

exports.__esModule = true;
exports.Validator = void 0;

var _hooks = require("@bydesign-ui/hooks");

var _utils = require("@bydesign-ui/utils");

var _priorityQueue = require("../../../models/priority-queue");

var _types = require("../types");

var _util = require("../util");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function getDefaultValidateResult(needValidate) {
  if (needValidate === void 0) {
    needValidate = false;
  }

  return {
    valid: true,
    partial: needValidate,
    msg: ''
  };
}

var Validator = function (_Emitter) {
  _inheritsLoose(Validator, _Emitter);

  function Validator(context) {
    var _this;

    _this = _Emitter.call(this) || this;
    _this.result = getDefaultValidateResult();
    _this.rules = [];
    _this.manual = false;
    _this.state = 'reset';
    _this.validateQueue = _this.initValidateQueue();
    _this.context = context;
    return _this;
  }

  var _proto = Validator.prototype;

  _proto.updateRules = function updateRules(rules) {
    if (!(0, _utils.deepEqual)(this.rules, rules)) {
      this.rules = rules;

      if (this.state === 'reset') {
        this.result = getDefaultValidateResult(this.rules.length > 0);
      }

      return true;
    }

    return false;
  };

  _proto.updateValue = function updateValue(value, manual) {
    if (manual === void 0) {
      manual = false;
    }

    this.manual = this.manual || manual;

    if (this.value !== value) {
      this.value = value;

      if (this.manual || this.state !== 'reset') {
        return true;
      }
    }

    return false;
  };

  _proto.validate = function validate(state) {
    var level = state ? state : this.manual ? 'change' : 'reset';

    if (_types.TriggerTypeMap[this.state] < _types.TriggerTypeMap[level]) {
      this.state = level;
    }

    return this.validateQueue.execute('validate', null);
  };

  _proto.getValidateInfo = function getValidateInfo() {
    return _extends({
      manual: this.manual
    }, this.result);
  };

  _proto.reset = function reset() {
    this.result = getDefaultValidateResult(this.rules.length > 0);
    this.manual = false;
    this.state = 'reset';
    this.emit('change', this.result);
  };

  _proto.dispose = function dispose() {
    this.reset();
    this.removeAllListeners('change');
  };

  _proto.initValidateQueue = function initValidateQueue() {
    var _this2 = this;

    return new _priorityQueue.PriorityQueue([{
      key: 'validate',
      fn: function fn(validateQueue, payload, level) {
        return (0, _util.validate)(_this2.context, _this2.rules, _this2.value, _this2.state).then(function (result) {
          var taskInfo = _this2.validateQueue.getTaskInfo('validate');

          if (taskInfo && level && taskInfo.runLevel > level) {
            return;
          }

          _this2.state = 'reset';

          if ((0, _utils.shallowEqual)(result, _this2.result)) {
            return;
          }

          _this2.result = result;

          _this2.emit('change', result);
        });
      }
    }]);
  };

  return Validator;
}(_hooks.Emitter);

exports.Validator = Validator;